export const CALL_QUEUE_NOTIFICATION_SRC =
  "https://tellescope-information.s3.us-east-2.amazonaws.com/sounds/level-up-191997.mp3";
